import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

const isAuthenticated = () => {
  // Simple check: token in localStorage
  return !!localStorage.getItem('token');
};

const isAdmin = () => {
  return localStorage.getItem('isAdmin') === 'true';
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, adminOnly }) => {
  const location = useLocation();
  if (!isAuthenticated()) {
    // Redirect to login, preserve intended path
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (adminOnly && !isAdmin()) {
    // Not an admin, redirect to home
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
